export const name =
`商品名は、この商品を管理のために区別するための名前です。<br><br>
販売名でも問題ありません。`;

